var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var BusinessModelIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 54,
    glyphHeight: 54
  }), React.createElement("path", {
    d: "M43.5305 21.3217C49.3739 21.3217 53.9652 16.7304 53.9652 10.8869C53.9652 5.04345 49.3739 0.452148 43.5305 0.452148C37.687 0.452148 33.0957 5.04345 33.0957 10.8869C33.0957 12.1391 33.3044 13.1826 33.7218 14.2261L30.1739 17.5652V7.13041L26 2.9565L21.8261 7.13041V17.5652L15.5652 11.3043H9.30437V17.5652L15.5652 23.8261H5.13046L0.956543 28L5.13046 32.1739H15.5652L9.30437 38.4348V44.6956H15.5652L21.8261 38.4348V48.8695L26 53.0435L30.1739 48.8695V38.4348L36.4348 44.6956H42.6957V38.4348L36.4348 32.1739H46.8696L51.0435 28L46.8696 23.8261H36.4348L39.7739 20.4869C41.0261 20.9043 42.2783 21.3217 43.5305 21.3217ZM26 34.2608C22.4522 34.2608 19.7392 31.5478 19.7392 28C19.7392 24.4522 22.4522 21.7391 26 21.7391C29.5478 21.7391 32.2609 24.4522 32.2609 28C32.2609 31.5478 29.5478 34.2608 26 34.2608ZM37.2696 11.3043C37.2696 11.0956 37.2696 10.8869 37.2696 10.8869C37.2696 7.33911 39.9826 4.62606 43.5305 4.62606C47.0783 4.62606 49.7913 7.33911 49.7913 10.8869C49.7913 14.4348 47.0783 17.1478 43.5305 17.1478C43.3218 17.1478 42.9044 17.1478 42.6957 17.1478C39.7739 16.5217 37.4783 14.2261 37.2696 11.3043Z",
    fill: "black"
  }));
};
export var BusinessModelIconGlyph = function (props) {
  return React.createElement(BusinessModelIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};